export function clamp(n: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, n));
}

export function parseTimeToMinutes(timeHHMM: string): number | null {
  const match = /^([0-9]{2}):([0-9]{2})$/.exec(timeHHMM);
  if (!match) return null;

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;

  return hours * 60 + minutes;
}

export function minutesToTimeHHMM(totalMinutes: number): string {
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function suggestEndTimeHHMM(startTimeHHMM: string, durationMinutes = 120): string | null {
  const minutes = parseTimeToMinutes(startTimeHHMM);
  if (minutes == null) return null;

  // Keep within the day; UI uses 15-min steps so cap at 23:45.
  const capped = clamp(minutes + durationMinutes, 0, 23 * 60 + 45);
  return minutesToTimeHHMM(capped);
}
